import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Event } from 'vscode/vscode/vs/base/common/event';
import { Disposable, MutableDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import './media/stickyScroll.css.js';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { IKeybindingService } from 'vscode/vscode/vs/platform/keybinding/common/keybinding.service';
import { TerminalInstance, TerminalInstanceColorProvider } from '../../../terminal/browser/terminalInstance.js';
import { TerminalStickyScrollOverlay } from './terminalStickyScrollOverlay.js';

var TerminalStickyScrollContribution_1;
let TerminalStickyScrollContribution = class TerminalStickyScrollContribution extends Disposable {
    static { TerminalStickyScrollContribution_1 = this; }
    static { this.ID = 'terminal.stickyScroll'; }
    static get(instance) {
        return instance.getContribution(TerminalStickyScrollContribution_1.ID);
    }
    constructor(_instance, processManager, widgetManager, _configurationService, _contextKeyService, _instantiationService, _keybindingService) {
        super();
        this._instance = _instance;
        this._configurationService = _configurationService;
        this._contextKeyService = _contextKeyService;
        this._instantiationService = _instantiationService;
        this._keybindingService = _keybindingService;
        this._overlay = this._register(( new MutableDisposable()));
        this._enableListeners = this._register(( new MutableDisposable()));
        this._disableListeners = this._register(( new MutableDisposable()));
        this._register(Event.runAndSubscribe(this._configurationService.onDidChangeConfiguration, e => {
            if (!e || e.affectsConfiguration("terminal.integrated.stickyScroll.enabled" )) {
                this._refreshState();
            }
        }));
    }
    xtermReady(xterm) {
        this._xterm = xterm;
        this._refreshState();
    }
    xtermOpen(xterm) {
        this._refreshState();
    }
    hideLock() {
        this._overlay.value?.lockHide();
    }
    hideUnlock() {
        this._overlay.value?.unlockHide();
    }
    _refreshState() {
        if (this._overlay.value) {
            this._tryDisable();
        }
        else {
            this._tryEnable();
        }
        if (this._overlay.value) {
            this._enableListeners.clear();
            if (!this._disableListeners.value) {
                this._disableListeners.value = this._instance.capabilities.onDidRemoveCapability(e => {
                    if (e.id === 2 ) {
                        this._refreshState();
                    }
                });
            }
        }
        else {
            this._disableListeners.clear();
            if (!this._enableListeners.value) {
                this._enableListeners.value = this._instance.capabilities.onDidAddCapability(e => {
                    if (e.id === 2 ) {
                        this._refreshState();
                    }
                });
            }
        }
    }
    _tryEnable() {
        if (this._shouldBeEnabled()) {
            const xtermCtorEventually = TerminalInstance.getXtermConstructor(this._keybindingService, this._contextKeyService);
            this._overlay.value = this._instantiationService.createInstance(TerminalStickyScrollOverlay, this._instance, this._xterm, this._instantiationService.createInstance(TerminalInstanceColorProvider, this._instance), this._instance.capabilities.get(2 ), xtermCtorEventually);
        }
    }
    _tryDisable() {
        if (!this._shouldBeEnabled()) {
            this._overlay.clear();
        }
    }
    _shouldBeEnabled() {
        const capability = this._instance.capabilities.get(2 );
        return !!(this._configurationService.getValue("terminal.integrated.stickyScroll.enabled" ) && capability && this._xterm?.raw?.element);
    }
};
TerminalStickyScrollContribution = TerminalStickyScrollContribution_1 = ( __decorate([
    ( __param(3, IConfigurationService)),
    ( __param(4, IContextKeyService)),
    ( __param(5, IInstantiationService)),
    ( __param(6, IKeybindingService))
], TerminalStickyScrollContribution));

export { TerminalStickyScrollContribution };
